module.exports = __webpack_public_path__ + "./fonts/GrettanaBold-GOnBm.ttf";